// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-overlay {
    --overlay-bg:
        radial-gradient(circle at 15% 20%, rgba(255, 180, 120, 0.28), transparent 45%),
        radial-gradient(circle at 85% 15%, rgba(255, 120, 120, 0.18), transparent 38%),
        linear-gradient(160deg, rgba(250, 245, 240, 0.92), rgba(238, 246, 255, 0.88));
    --card-bg: rgba(255, 255, 255, 0.82);
    --card-border: rgba(255, 255, 255, 0.65);
    --title-color: #16212e;
    --text-color: #405164;
    --track-bg: rgba(209, 221, 234, 0.75);
    --progress-bg: linear-gradient(90deg, #ff8a5b, #ff5f6d 55%, #ef476f 100%);
    --spinner-track: rgba(204, 216, 229, 0.65);
    --spinner-top: #ff6f61;
    --cancel-bg: linear-gradient(135deg, #d9455f, #b02a4e);
    --cancel-bg-hover: linear-gradient(135deg, #c33b56, #982246);
    --cancel-shadow: rgba(172, 37, 76, 0.35);
    --card-shadow: 0 18px 48px rgba(24, 39, 65, 0.28);

    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    padding: 24px;
    background: var(--overlay-bg);
    backdrop-filter: blur(8px) saturate(140%);
    -webkit-backdrop-filter: blur(8px) saturate(140%);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.loading-card {
    position: relative;
    isolation: isolate;
    background: var(--card-bg);
    border: 1px solid var(--card-border);
    padding: 30px 28px 24px;
    border-radius: 18px;
    width: min(360px, calc(100vw - 48px));
    text-align: center;
    box-shadow: var(--card-shadow);
}

.loading-card::before {
    content: "";
    position: absolute;
    inset: -1px;
    border-radius: 18px;
    background: linear-gradient(145deg, rgba(255, 255, 255, 0.82), rgba(255, 255, 255, 0.1));
    opacity: 0.5;
    z-index: -1;
}

.loading-card h4 {
    margin: 16px 0 7px 0;
    font-size: 1.15rem;
    font-weight: 700;
    letter-spacing: 0.01em;
    color: var(--title-color);
}

.loading-card p {
    margin: 0 0 18px 0;
    font-size: 0.92rem;
    color: var(--text-color);
}

.progress-bar-container {
    width: 100%;
    height: 10px;
    background: var(--track-bg);
    border-radius: 999px;
    overflow: hidden;
    margin-bottom: 18px;
}

.progress-fill {
    height: 100%;
    width: 0%;
    background: var(--progress-bg);
    border-radius: inherit;
    transition: width 0.18s ease;
}

.spinner {
    margin: 0 auto;
    width: 44px;
    height: 44px;
    border: 4px solid var(--spinner-track);
    border-top: 4px solid var(--spinner-top);
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.3), 0 8px 18px rgba(15, 20, 35, 0.1);
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

/* ─── ACTION BUTTON STYLING ─── */
.btn-cancel {
    background: var(--cancel-bg);
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.22);
    padding: 10px 16px;
    font-size: 0.85rem;
    font-weight: 700;
    letter-spacing: 0.01em;
    border-radius: 10px;
    cursor: pointer;
    width: 100%;
    box-shadow: 0 10px 20px -12px var(--cancel-shadow);
    transition: transform 0.18s ease, filter 0.18s ease, background 0.18s ease;
}

.btn-cancel:hover {
    background: var(--cancel-bg-hover);
    transform: translateY(-1px);
}

.btn-cancel:disabled {
    opacity: 0.65;
    cursor: not-allowed;
    transform: none;
    filter: grayscale(0.15);
}

@media (prefers-color-scheme: dark) {
    .loading-overlay {
        --overlay-bg:
            radial-gradient(circle at 18% 25%, rgba(255, 156, 96, 0.23), transparent 44%),
            radial-gradient(circle at 80% 18%, rgba(255, 88, 124, 0.2), transparent 38%),
            linear-gradient(155deg, rgba(14, 18, 25, 0.92), rgba(12, 28, 44, 0.9));
        --card-bg: rgba(20, 30, 42, 0.78);
        --card-border: rgba(136, 166, 196, 0.28);
        --title-color: #e6eff8;
        --text-color: #b9c7d6;
        --track-bg: rgba(73, 92, 114, 0.65);
        --progress-bg: linear-gradient(90deg, #ff9e64, #ff6b6b 52%, #f45b69 100%);
        --spinner-track: rgba(91, 112, 136, 0.65);
        --spinner-top: #ff9a62;
        --cancel-bg: linear-gradient(135deg, #d45066, #9f2a4f);
        --cancel-bg-hover: linear-gradient(135deg, #e35a72, #b63157);
        --cancel-shadow: rgba(0, 0, 0, 0.5);
        --card-shadow: 0 18px 50px rgba(3, 8, 15, 0.6);
    }
}
`, "",{"version":3,"sources":["webpack://./lino_react/react/components/LinoCodex.css"],"names":[],"mappings":"AAAA;IACI;;;qFAGiF;IACjF,oCAAoC;IACpC,wCAAwC;IACxC,sBAAsB;IACtB,qBAAqB;IACrB,qCAAqC;IACrC,yEAAyE;IACzE,0CAA0C;IAC1C,sBAAsB;IACtB,sDAAsD;IACtD,4DAA4D;IAC5D,wCAAwC;IACxC,iDAAiD;;IAEjD,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,aAAa;IACb,6BAA6B;IAC7B,yCAAyC;IACzC,iDAAiD;IACjD,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;IAC1B,oCAAoC;IACpC,uBAAuB;IACvB,mBAAmB;IACnB,qCAAqC;IACrC,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,wFAAwF;IACxF,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,8BAA8B;IAC9B,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,wCAAwC;IACxC,kBAAkB;IAClB,oCAAoC;IACpC,gFAAgF;AACpF;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA,kCAAkC;AAClC;IACI,4BAA4B;IAC5B,YAAY;IACZ,2CAA2C;IAC3C,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,kDAAkD;IAClD,0EAA0E;AAC9E;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI;QACI;;;kFAG0E;QAC1E,iCAAiC;QACjC,wCAAwC;QACxC,sBAAsB;QACtB,qBAAqB;QACrB,mCAAmC;QACnC,yEAAyE;QACzE,yCAAyC;QACzC,sBAAsB;QACtB,sDAAsD;QACtD,4DAA4D;QAC5D,mCAAmC;QACnC,8CAA8C;IAClD;AACJ","sourcesContent":[".loading-overlay {\n    --overlay-bg:\n        radial-gradient(circle at 15% 20%, rgba(255, 180, 120, 0.28), transparent 45%),\n        radial-gradient(circle at 85% 15%, rgba(255, 120, 120, 0.18), transparent 38%),\n        linear-gradient(160deg, rgba(250, 245, 240, 0.92), rgba(238, 246, 255, 0.88));\n    --card-bg: rgba(255, 255, 255, 0.82);\n    --card-border: rgba(255, 255, 255, 0.65);\n    --title-color: #16212e;\n    --text-color: #405164;\n    --track-bg: rgba(209, 221, 234, 0.75);\n    --progress-bg: linear-gradient(90deg, #ff8a5b, #ff5f6d 55%, #ef476f 100%);\n    --spinner-track: rgba(204, 216, 229, 0.65);\n    --spinner-top: #ff6f61;\n    --cancel-bg: linear-gradient(135deg, #d9455f, #b02a4e);\n    --cancel-bg-hover: linear-gradient(135deg, #c33b56, #982246);\n    --cancel-shadow: rgba(172, 37, 76, 0.35);\n    --card-shadow: 0 18px 48px rgba(24, 39, 65, 0.28);\n\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    padding: 24px;\n    background: var(--overlay-bg);\n    backdrop-filter: blur(8px) saturate(140%);\n    -webkit-backdrop-filter: blur(8px) saturate(140%);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n}\n\n.loading-card {\n    position: relative;\n    isolation: isolate;\n    background: var(--card-bg);\n    border: 1px solid var(--card-border);\n    padding: 30px 28px 24px;\n    border-radius: 18px;\n    width: min(360px, calc(100vw - 48px));\n    text-align: center;\n    box-shadow: var(--card-shadow);\n}\n\n.loading-card::before {\n    content: \"\";\n    position: absolute;\n    inset: -1px;\n    border-radius: 18px;\n    background: linear-gradient(145deg, rgba(255, 255, 255, 0.82), rgba(255, 255, 255, 0.1));\n    opacity: 0.5;\n    z-index: -1;\n}\n\n.loading-card h4 {\n    margin: 16px 0 7px 0;\n    font-size: 1.15rem;\n    font-weight: 700;\n    letter-spacing: 0.01em;\n    color: var(--title-color);\n}\n\n.loading-card p {\n    margin: 0 0 18px 0;\n    font-size: 0.92rem;\n    color: var(--text-color);\n}\n\n.progress-bar-container {\n    width: 100%;\n    height: 10px;\n    background: var(--track-bg);\n    border-radius: 999px;\n    overflow: hidden;\n    margin-bottom: 18px;\n}\n\n.progress-fill {\n    height: 100%;\n    width: 0%;\n    background: var(--progress-bg);\n    border-radius: inherit;\n    transition: width 0.18s ease;\n}\n\n.spinner {\n    margin: 0 auto;\n    width: 44px;\n    height: 44px;\n    border: 4px solid var(--spinner-track);\n    border-top: 4px solid var(--spinner-top);\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.3), 0 8px 18px rgba(15, 20, 35, 0.1);\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n/* ─── ACTION BUTTON STYLING ─── */\n.btn-cancel {\n    background: var(--cancel-bg);\n    color: white;\n    border: 1px solid rgba(255, 255, 255, 0.22);\n    padding: 10px 16px;\n    font-size: 0.85rem;\n    font-weight: 700;\n    letter-spacing: 0.01em;\n    border-radius: 10px;\n    cursor: pointer;\n    width: 100%;\n    box-shadow: 0 10px 20px -12px var(--cancel-shadow);\n    transition: transform 0.18s ease, filter 0.18s ease, background 0.18s ease;\n}\n\n.btn-cancel:hover {\n    background: var(--cancel-bg-hover);\n    transform: translateY(-1px);\n}\n\n.btn-cancel:disabled {\n    opacity: 0.65;\n    cursor: not-allowed;\n    transform: none;\n    filter: grayscale(0.15);\n}\n\n@media (prefers-color-scheme: dark) {\n    .loading-overlay {\n        --overlay-bg:\n            radial-gradient(circle at 18% 25%, rgba(255, 156, 96, 0.23), transparent 44%),\n            radial-gradient(circle at 80% 18%, rgba(255, 88, 124, 0.2), transparent 38%),\n            linear-gradient(155deg, rgba(14, 18, 25, 0.92), rgba(12, 28, 44, 0.9));\n        --card-bg: rgba(20, 30, 42, 0.78);\n        --card-border: rgba(136, 166, 196, 0.28);\n        --title-color: #e6eff8;\n        --text-color: #b9c7d6;\n        --track-bg: rgba(73, 92, 114, 0.65);\n        --progress-bg: linear-gradient(90deg, #ff9e64, #ff6b6b 52%, #f45b69 100%);\n        --spinner-track: rgba(91, 112, 136, 0.65);\n        --spinner-top: #ff9a62;\n        --cancel-bg: linear-gradient(135deg, #d45066, #9f2a4f);\n        --cancel-bg-hover: linear-gradient(135deg, #e35a72, #b63157);\n        --cancel-shadow: rgba(0, 0, 0, 0.5);\n        --card-shadow: 0 18px 50px rgba(3, 8, 15, 0.6);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
